import React, { Component } from 'react';

class BuyVideo extends Component {
  addScript(url) {
    const script1 = document.createElement("script");
    script1.src = url;
    script1.async = true;
    document.getElementById("buy-video").appendChild(script1);
  }

  componentDidMount() {
    this.addScript("https://fast.wistia.com/embed/medias/videolink.jsonp");
    this.addScript("https://fast.wistia.com/assets/external/E-v1.js");
  }

  render() {
    return (
      <div id="buy-video">
        <div className="wistia_embed wistia_async_vobk3g4rpc popover=true popoverAnimateThumbnail=true" />
      </div>
    )
  }
}

export default BuyVideo;



// WEBPACK FOOTER //
// ./src/components/buy_video.js